module.exports = __webpack_public_path__ + "723ce4cdd1a6aeceb03731a47225e14d.png";